import { render, staticRenderFns } from "./CriterioSelectLojas.vue?vue&type=template&id=b8aed820"
import script from "./CriterioSelectLojas.vue?vue&type=script&lang=js"
export * from "./CriterioSelectLojas.vue?vue&type=script&lang=js"
import style0 from "./CriterioSelectLojas.vue?vue&type=style&index=0&id=b8aed820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports